// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cFgI1","tabsBox":"styles_tabsBox__2kzXm","createButton":"styles_createButton__1GAJn"};